import React, { useState } from 'react'
import { Dialog } from 'components'
import { Button } from '@mui/material'
import {
  useUpdateStudentValidationStatusMutation,
  useGetRejectReasonsQuery,
} from 'features'
import { useDispatch } from 'react-redux'
import { successSnack } from 'features/snack-bar/snackSlice'

/**
 *
 * @param {*} _props
 * @returns
 */
export default function SetRejectReason(_props) {
  const {
    togglerComponent: Component = { Button },
    children,
    togglerProps = {},
    rowData = {},
    callback = null,
    rejectReasons = [],
  } = _props

  const [open, setOpen] = useState(false)

  const dispatch = useDispatch()

  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    setOpen(false)
  }

  const [rejectStudent] = useUpdateStudentValidationStatusMutation()

  function handleSubmit(data) {
    const mutation = rejectStudent({
      approved: false,
      studentid: rowData.studentid,
      reason: data.rejectreasonid,
      observation: data.observation,
    })
    mutation
      .then((response) => {
        if (response?.data?.message === 'done') {
          dispatch(
            successSnack({
              message: `Alumno/a ${
                Boolean(rowData.firstname) ? rowData.firstname + ' ' : ''
              }${
                Boolean(rowData.lastname) ? rowData.lastname + ' ' : ''
              } ha sido rechazado/a`,
            })
          )
          closeDialog()
          if (callback) {
            callback()
          }
        }
      })
      .catch((error) => {})
  }

  const message = `Selecciona el motivo de rechazo para el alumno/a`

  return (
    <>
      <Component onClick={openDialog} {...togglerProps}>
        {children}
      </Component>
      {open && (
        <Dialog
          open={open}
          handleClose={closeDialog}
          primaryButtonText={
            rowData?.state === 'r' ? 'Actualizar motivo' : 'Rechazar'
          } //Label of the primary button
          secondaryButtonText="Cancelar" // Label of the cancel button
          title={`Motivo de rechazo`} // 'Dialog title'
          message={message}
          onSubmit={handleSubmit} // Form submit action
          fields={[
            {
              name: 'rejectreasonid',
              helperText: `Selecciona el motivo de rechazo para el alumno/a`,
              label: 'Motivo de Rechazo',
              type: 'select',
              validation: {
                required: 'Debe seleccionar un motivo de rechazo',
              },
              options: rejectReasons?.map((reason) => ({
                value: reason.rejectreasonid,
                label: reason.reason,
              })),
            },
            {
              name: 'observation',
              helperText: `Introduce una observación para este rechazo`,
              label: 'Observaciones',
              type: 'text',
              validation: {},
            },
          ]}
        />
      )}
    </>
  )
}
